import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { map, Observable } from "rxjs";
import { SessionTimeoutService } from "@core/services/session-timeout.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-session-timeout-dialog",
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./session-timeout-dialog.component.html",
  styleUrls: ["./session-timeout-dialog.component.scss"],
})
export class SessionTimeoutDialogComponent {
  private readonly sessionTimeoutService = inject(SessionTimeoutService);

  timeRemainingFormatted$: Observable<string> = this.sessionTimeoutService.state$.pipe(
    map((state) => this.formatTime(state.timeRemaining)),
    takeUntilDestroyed(),
  );

  private formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
}
